/**
 * The id + timestamp seam. Real elements mint a UUIDv7 and read the wall clock;
 * tests inject a deterministic clock so goldens and VM assertions are stable.
 */

/** Produces event ids and ISO timestamps for appended review events. */
export interface RlhfClock {
  now(): string
  newId(): string
}

/** The production clock: browser-native UUID ids + the current ISO time. */
export const systemClock = (): RlhfClock => ({
  now: () => new Date().toISOString(),
  newId: () => crypto.randomUUID(),
})
